function ExitX() {
  function Xsvg() {
    return (
      <svg
        width="38"
        height="46"
        viewBox="0 0 38 46"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{ cursor: "pointer" }}
      >
        {/* <rect width="38" height="46" fill="#1E1E1E" /> */}
        {/* <g clip-path="url(#clip0_0_1)"> */}
        <path
          d="M4.73999 4.81006C8.98999 19.4901 20.05 37.0101 36.6 43.6301"
          stroke="#000000"
          strokeWidth="5"
          strokeMiterlimit="10"
          style={{ cursor: "pointer" }}
        />
        <path
          d="M1.59 43.63C17.46 30.53 24.38 22.73 29.31 0.540039"
          stroke="#000000"
          strokeWidth="5"
          strokeMiterlimit="10"
          style={{ cursor: "pointer" }}
        />
        {/* </g> */}
      </svg>
    );
  }

  return <Xsvg />;
}

export default ExitX;
